import React, { Fragment, useContext, useState, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomizerContext from '../../../../_helper/Customizer';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ApplicationApi, ModuleApi, TaskApi } from '../../../../api';
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../../Common/Component/CardRibbonWithForm';
import { base_form_fields, code_field, createDropdownField, external_url_field, icon_field, visibility_field } from '../../../../Data/FormField/PublicData';
import useAxiosPrivate from '../../../../Hooks/useAxiosPrivate';
import { ApplicationName, CountryName, ModuleName, TaskName } from '../../../../Constant';

const TaskNew = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const axiosPrivate = useAxiosPrivate()
  const lists = `${process.env.PUBLIC_URL}/access-control/tasks/${layoutURL}`;

  const { formState: { errors },} = useForm(); 

  const [formFields, setFormFields] = useState(base_form_fields(`${TaskName}`));
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);

  const ApplicationDropDown = createDropdownField(axiosPrivate,
    'application_id',
    'application_id',
    `${ApplicationName}`,
    `${ApplicationApi}`,
    '', 12
  );
  const ModuleDropDown = createDropdownField(axiosPrivate,
    'module_id',
    'module_id',
    `${ModuleName}`,
    `${ModuleApi}`,
    '', 12
  );

  useEffect(() => {

    const fetchData = async () => {
      try {
        if (!isNewFieldAdded) {
          
          const indexOfName = formFields.findIndex((formField) => formField.id === 'name');
          const indexOfDesc = formFields.findIndex((formField) => formField.id === 'description');
    
          const updatedFields = [ApplicationDropDown, ModuleDropDown, ...formFields];
          updatedFields.splice(indexOfName + 3, 0, code_field());
          updatedFields.splice(indexOfDesc + 4, 0, icon_field(), external_url_field(), visibility_field);
          
  
          await updatedFields[0].fetchOptions();
          
          setFormFields(updatedFields);
          setIsNewFieldAdded(true);
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
    };

    fetchData();

  }, [formFields, isNewFieldAdded, ApplicationDropDown, ModuleDropDown]); 

  ApplicationDropDown.onChange = async (selectedOptionId, updatedFields) => { 
    const moduleField = updatedFields.find((field) => field.id === 'module_id');
    
    if (moduleField) {
      await moduleField.fetchOptions(selectedOptionId);
      setFormFields([...updatedFields]);
    } 
  };

  const addNewRecord =  async (newRecord) => {
      if (newRecord === '') { 
        errors.showMessages();
      }

      const newRecordTemp = {
          module_id: newRecord.module_id,
          name: newRecord.name,
          code: newRecord.code,
          icon: newRecord.icon,
          description: newRecord.description,
          visibility: newRecord.visibility,
          external_url: newRecord.external_url,
          is_active: newRecord.is_active,
      };

      try {
          await axiosPrivate.post(TaskApi, newRecordTemp).then((resp) => {
            toast.success(`${resp.data.name} is successfully added.`)
            history(lists);
          });
      } catch (error) {
        if (error.response && error.response.status === 422) {
            toast.error('Validation Errors');
          } else if (error.response && error.response.status === 400) {
            toast.error(error.response.data.detail);
          } else {
            toast.error('Form submission error');
          }
        throw error;
    }   
  };


  return (
    <Fragment>
      <Breadcrumbs parent="Access Control" title="New Task" mainTitle="New Task" />
      <Container fluid={true}>
        <Row>
          <Col sm='10'>
            <CardRibbonWithForm formFields={formFields} onSubmit={addNewRecord} ribbonUrl={lists} />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default TaskNew;